/**
 * Owner-admin schema browser (read-only DB introspection).
 * All under /api/admin/v2/schema/*, IsSuperuser-gated server-side.
 */
import api from "./axios";

export const getSchemaTree = () => api.get("/api/admin/v2/schema/");

export const getSchemaModel = (app, model) =>
  api.get(`/api/admin/v2/schema/${app}/${model}/`);

export const getSchemaModelRows = (app, model, { limit = 25, offset = 0, search = "" } = {}) =>
  api.get(`/api/admin/v2/schema/${app}/${model}/rows/`, {
    params: { limit, offset, ...(search ? { search } : {}) },
  });

/**
 * Schema chatbot — natural-language Q&A over the live DB (read-only).
 * @param {Array<{role:"user"|"assistant",content:string}>} messages
 * @param {{ model?: string }} opts
 */
export const postSchemaChat = (messages, { model } = {}) =>
  api.post("/api/admin/v2/schema/chat/", {
    messages,
    ...(model ? { model } : {}),
  });
